/* eslint-disable react-hooks/exhaustive-deps */
import { Alert } from "@mui/material";
import React, { useRef, useState } from "react";
import { useAppSelector } from "../../app/hooks";
import {
  Card,
  CardBody,
  CardTitle,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";

import { LoadingPanel } from "../../components/layout/Loading";
import ToggleTab from "./ToggleTab";
import {
  FaRegStickyNote,
  FaTasks,
  FaMicrophoneAlt,
  FaPhoneAlt,
  FaPaperclip,
  FaUsers,
} from "react-icons/fa";
import ActivityLogCard from "../../components/common/ActivityLogCard";
import { Input } from "@progress/kendo-react-inputs";

type ActivityTabProps = {
  client: boolean;
};
const ActivityTab: React.FC<ActivityTabProps> = ({ client }) => {
  const alignment = useAppSelector((state) => state.activityLog.alignment);
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.activityLog.loading);
  const ClientActivityLogsList = useAppSelector(
    (state) => state.activityLog.ClientActivityLogsList
  );
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = searchTerm
    ? ClientActivityLogsList?.filter((item: any) =>
        [
          item?.ActivityTitle,
          item?.ActivityDescription,
          item?.CreatedOn,
          item?.ActivityDate,
          item?.ActivityType,
          item?.ActivityStutas,
          item?.ActivityOwnName,
        ].some((field: any) =>
          field?.toLowerCase()?.includes(searchTerm?.toLowerCase())
        )
      )
    : ClientActivityLogsList;

  const currentTab = useAppSelector((state) => state.activityLog.currentTab);
  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <GridLayout style={{ width: "100%" }}>
      <GridLayout
        style={{
          marginTop: 8,
          marginBottom: 8,
        }}
      >
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <ToggleTab />
          <Input
            style={{ width: 350 }}
            placeholder="Type here to search..."
            value={searchTerm}
            onChange={(e: any) => {
              setSearchTerm(e.target.value);
            }}
          />
        </GridLayoutItem>
      </GridLayout>
      <Card>
        <CardBody>
          <CardTitle style={{ fontWeight: "bold", marginBottom: "25px" }}>
            {alignment !== "UPCOMING" ? "Past" : "Upcoming"}
          </CardTitle>
          {filteredData && filteredData?.length > 0 ? (
            filteredData?.map((Activity: any) => (
              <>
                {Activity.ActivityLog === "CallLog" &&
                  (currentTab === "CALL" || currentTab === "ACTIVITY") && (
                    <ActivityLogCard
                      client={client}
                      activity={Activity}
                      icon={FaPhoneAlt}
                      activityType="Call"
                      color="#124e78"
                    />
                  )}
                {Activity.ActivityLog === "TaskLog" &&
                  (currentTab === "TASK" || currentTab === "ACTIVITY") && (
                    <ActivityLogCard
                      client={client}
                      activity={Activity}
                      icon={FaTasks}
                      activityType="Task"
                      color="#ff7f11"
                    />
                  )}
                {Activity.ActivityLog === "MeetingLog" &&
                  (currentTab === "MEETING" || currentTab === "ACTIVITY") && (
                    <ActivityLogCard
                      client={client}
                      activity={Activity}
                      icon={FaUsers}
                      activityType="Meeting"
                      color="#f2bb05"
                    />
                  )}
                {Activity.ActivityLog === "NoteLog" &&
                  (currentTab === "NOTE" || currentTab === "ACTIVITY") && (
                    <ActivityLogCard
                      client={client}
                      activity={Activity}
                      icon={FaRegStickyNote}
                      activityType="Note"
                      color="#d74e09"
                    />
                  )}
                {Activity.ActivityLog === "AttachmentLog" &&
                  (currentTab === "ATTACHMENT" ||
                    currentTab === "ACTIVITY") && (
                    <ActivityLogCard
                      client={client}
                      activity={Activity}
                      icon={FaPaperclip}
                      activityType="Attachment"
                      color="#826aed"
                    />
                  )}
                {Activity.ActivityLog === "RecodingLog" &&
                  (currentTab === "RECORDING" || currentTab === "ACTIVITY") && (
                    <ActivityLogCard
                      client={client}
                      activity={Activity}
                      icon={FaMicrophoneAlt}
                      activityType="Recording"
                      color="#1e555c"
                    />
                  )}
              </>
            ))
          ) : (
            <Alert severity="error">No Data Found</Alert>
          )}
        </CardBody>
      </Card>
    </GridLayout>
  );
};

export default ActivityTab;
